var _path, _path2, _path3, _path4, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFondoWavesComplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 393,
    height: 852,
    viewBox: "0 0 393 852",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M343 1000.5L92.5 943L-70 902V-91H200C211.333 -57 155.7 -68.8 84.5 90C-4.5 288.5 509 663.5 516.5 747.5C522.5 814.7 382.667 989.167 343 1000.5Z",
    fill: "#1E1E1E",
    fillOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-11 880V-56L289.873 -49.5C189.582 11.3333 26.4567 190.5 176.283 420.5C326.11 650.5 312.59 822.667 287.102 880H-11Z",
    fill: "#00A651",
    fillOpacity: 0.33
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-34 882V-54L266.873 -47.5C166.582 13.3333 3.4567 192.5 153.283 422.5C303.11 652.5 289.59 824.667 264.102 882H-34Z",
    fill: "#00A651",
    fillOpacity: 0.66
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-42 880V-56L229.5 -49.5C139 11.3333 -8.2 190.5 127 420.5C262.2 650.5 250 822.667 227 880H-42Z",
    fill: "#00A651"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 461.922,
    y: -84,
    width: 182,
    height: 182,
    rx: 91,
    transform: "rotate(88.3191 461.922 -84)",
    fill: "#00A651",
    fillOpacity: 0.33
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 447.634,
    y: -72,
    width: 154.7,
    height: 154.7,
    rx: 77.35,
    transform: "rotate(88.3191 447.634 -72)",
    fill: "#00A651",
    fillOpacity: 0.66
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 438.438,
    y: -61,
    width: 131.495,
    height: 131.495,
    rx: 65.7475,
    transform: "rotate(88.3191 438.438 -61)",
    fill: "#00A651"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFondoWavesComplete);
export default __webpack_public_path__ + "static/media/fondo_waves_complete.164a2f01b5f0784d908b7c510064e359.svg";
export { ForwardRef as ReactComponent };